<template>
  <div style="height: 100%; width: 100%; position: relative;">
    <!-- id="mappage"
      data-title="地图线路"
      class="page out"
      data-onpagefirstinto="mapFirstInto"
      data-callback="mapCallBack" -->
    <div style="
        position: absolute;
        top: 0;
        left: 0;
        background-color: #fcf9f2;
        z-index: 1;
        width: 100%;
      ">
      <Header :title="title" :showBack="true"></Header>
      <div class="map-tips">
        <div class="clearfix">
          <div>
            <!-- <span class="iconfont icon-shijian"></span>
            <span class="map-class-time">上车时间 {{ClassMapDataList.StartClassTime}}</span>-->
            <span class="ws-title">{{ wsTitle }}</span>
            <!-- <span class="map-class-distance">({{ClassMapDataList.Mileage}}公里 {{ClassMapDataList.RunTime | timeToStr}})</span> -->
          </div>
          <!-- <div class="map-class-price">￥{{ClassMapDataList.FullPrice}}</div> -->
        </div>
        <!-- <div class="clearfix">
          <div class="class-list-content">
            <div class="class-station">
              <span class="iconfont icon-yuandianzhong"></span>
              {{ goList.StartNodeName }}
            </div>
            <div class="class-node">
              <span class="iconfont icon-yuandianzhong"></span>
              {{ goList.ArrivalNodeName }}
            </div>
          </div>
          <div class="iconfont icon-jiantou_shangxiaqiehuan"></div>
        </div> -->
      </div>
    </div>
    <div id="map-container" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import mapUtil from "@/js/map.js";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "车辆位置", //页面标题
      LineClassDayGID: JSON.parse(window.localStorage.getItem("lineClassDay"))
        .GID, //班次GID
      VehicleGID: this.$route.query.VehicleGIDList, //车辆GID
      ClassMapDataList: "", //班次地图数据
      flag: true,
      ws: null,
      wsTitle: "",
      map: null, //地图
      nodeGis: null
    };
  },
  watch: {},
  methods: {
    //调整车辆图标方向
    doDirectionToAngle: function (Direction) {
      var deg;
      switch (Direction) {
        case "东":
          deg = 0;
          break;
        case "东南":
          deg = 45;
          break;
        case "南":
          deg = 90;
          break;
        case "西南":
          deg = 135;
          break;
        case "西":
          deg = 180;
          break;
        case "西北":
          deg = 225;
          break;
        case "北":
          deg = 275;
          break;
        case "东北":
          deg = 315;
          break;
        default:
          deg = 0;
          break;
      }
      return deg;
    },
    //获取班次站点坐标
    getClassMapData() {
      var that = this;
      let params = {
        LineClassDayGID: this.LineClassDayGID,
      };
      this.$http
        .post(this.$api.getMapData, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.ClassMapDataList = res.data[0];
            // 初始化地图
            this.map = mapUtil.init("map-container");

            if (!this.map) {
              this.$dialog.alert({
                title: "提示",
                message: "获取地图信息失败",
              });
              return;
            }
            //清除地图标记;
            mapUtil.clearMark(this.map);

            if (this.ClassMapDataList) {
              if (this.ws) {
                this.ws.close();
              }
              if (!window.WebSocket) {
                this.$dialog.alert({
                  title: "提示",
                  message: "您的浏览器不支持WebSocket，无法获取车辆位置。",
                });
                return;
              }
              var protocol = location.protocol === "https:" ? "wss:" : "ws:";
              //正式
              this.ws = new WebSocket(
                protocol +
                "//class.busboss.cn/api/gps?_Authorization=" +
                window.localStorage.getItem("_cyw_token") +
                "&VehicleGIDList=" +
                that.VehicleGID
              );
              //本地 localhost  192.168.137.1
              // this.ws = new WebSocket(
              //   protocol +
              //     '//localhost:1414/api/gps?VehicleGIDList=' +
              //     that.VehicleGID
              // )
              this.ws.onopen = function () {
                that.wsTitle = "正在持续查询车辆位置...";
              };
              this.ws.onmessage = function (evt) {
                let obj = JSON.parse(evt.data);
                if (!obj.success) {
                  that.wsTitle = "获取车辆定位失败";
                  return;
                }
                that.wsTitle = "正在持续查询车辆位置...";

                if (window.markerList != null) {
                  window.markerList.forEach((i) => {
                    that.map.remove(i);
                  });
                }
                obj.data.forEach((v) => {
                  mapUtil.driving(that.map, v.Lon + "," + v.Lat, "113.322519,23.130987", (error, result) => {
                    console.log(error)

                    console.log(result)
                  })
                  var deg = that.doDirectionToAngle(v.Direction);
                  // GCJ02 火星坐标系 再高德地图上可以直接显示
                  if (v.CoordTypeCode === "GCJ02") {
                    let option = {
                      lnglat: v.Lon + "," + v.Lat,
                      type: "bus",
                    };
                    let marker = mapUtil.createmark(that.map, option);
                    marker.setAngle(deg);
                    //marker.setTitle(v.VehicleNo);
                    marker.setLabel({
                      offset: { x: 20, y: 20 }, //设置文本标注偏移量
                      content: v.VehicleNo,
                      //direction:deg>180?'top':'top', //设置文本标注方位
                    });
                    window.markerList.push(marker);
                    //第一次获取到车辆位置 定位至车辆
                  } else {
                    // WGS84 地球坐标系 则需要调用地图JS返回将GPS坐标转换为高德坐标
                    // BD09 百度坐标系
                    mapUtil.convertFrom(
                      [v.Lon, v.Lat],
                      "gps",
                      that.map,
                      v.VehicleNo
                    );
                  }

                  if (that.flag) {
                    setTimeout(function () {
                      that.map.setFitView();
                      that.flag = false;
                    }, 20);
                  }
                });
              };
              this.ws.onerror = function (evt) {
                that.wsTitle = "服务器连接错误";
              };
              this.ws.onclose = function () {
                if (that.destroyed === true) {
                  return;
                }
                that.wsTitle = "连接关闭";
              };
            } else {
              this.$dialog.alert({
                title: "提示",
                message: "获取车辆坐标信息失败",
              });
            }
          }
        });
    },
  },
  mounted: function () {
    //this.getClassMapData();
  },
  created() {
    let that = this;
    window.markerList = [];
    window.onLoad = function () {
      that.getClassMapData();
    };
    window._AMapSecurityConfig = {
      securityJsCode: 'c6bcd7dc52ae28e9567c690ba7939b72',
    }
    var url =
      "https://webapi.amap.com/maps?v=1.4.12&key=24f21e97ad61f5d65b50a38c175b3fe4&callback=onLoad";
    var jsapi = document.createElement("script");
    jsapi.charset = "utf-8";
    jsapi.src = url;
    document.head.appendChild(jsapi);
    // 创建script标签，引入外部文件
    // let script = document.createElement("script");
    // script.type = "text/javascript";
    // script.src =
    //   "https://webapi.amap.com/maps?v=1.4.12&key=13c3c2b4b14658ea983e9629219a040e";
    // document.getElementsByTagName("head")[0].appendChild(script);
  },
  destroyed() {
    this.ws.close();
  },
};
</script>

<style scoped lang="less"></style>
